/**
 * Parse context tags from user messages
 * Supports: @reports:, @subject:, @subject:identifier:
 */

export const parseContextTag = (message) => {
  // Regex: @contextType:identifier: message OR @contextType: message
  const tagRegex = /^@(reports|analytics|subject)(?::([^\s:]+))?\s*:\s*(.+)$/i;
  const match = message.match(tagRegex);

  if (!match) {
    return {
      contextType: null,
      identifier: null,
      cleanMessage: message,
      originalMessage: message,
      hasTag: false
    };
  }

  // Normalize "analytics" alias to "reports"
  const rawType = match[1].toLowerCase();
  const contextType = rawType === 'analytics' ? 'reports' : rawType;

  return {
    contextType,                         // 'reports' | 'subject'
    identifier: match[2] || null,        // email, displayId, or null
    cleanMessage: match[3].trim(),       // message without tag
    originalMessage: message,
    hasTag: true
  };
};

export const validateContextTag = (parsedTag) => {
  if (!parsedTag.hasTag) {
    return { valid: true, error: null };
  }

  const { contextType, identifier } = parsedTag;

  if (!['reports', 'subject'].includes(contextType)) {
    return {
      valid: false,
      error: 'Invalid context type. Use @reports:, @analytics:, or @subject:'
    };
  }

  if (contextType === 'reports' && identifier) {
    return {
      valid: false,
      error: '@reports: does not support identifiers. Just use @reports: or @analytics:'
    };
  }

  return { valid: true, error: null };
};
